import React, { useState } from 'react';
import { Input, Button, Form, message } from 'antd';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import {baseUrl} from "../../../../src/config"
export const LoginPage = () => {
  const [formData, setFormData] = useState({
    username: '',
    password: '',
  });
  const navigate=useNavigate()
  const handleInputChange = (e, field) => {
    setFormData({
      ...formData,
      [field]: e.target.value,
    });
  };
  const handleSubmit = async () => {
    // Check if all fields are filled
    if (formData.username.trim() === '' || formData.password.trim() === '') {
      message.error('Please fill in both fields.');
      return;
    }

    console.log('Form Data:', formData);

    try {
      // Call login API with Axios
      const response = await axios.post(`${baseUrl}login`, formData);
      console.log('Login response:', response.data);
      
      // Handle success (for example, navigate to dashboard or show a success message)
      if (response.data) {
        localStorage.setItem("loginData", JSON.stringify(response.data));
        message.success('Login successful!');
        navigate("/admin/enquiries")
        // Redirect to another page or perform other actions
        // e.g., navigate('/dashboard');
      } else {
        message.error('Invalid username or password');
      }
    } catch (error) {
      console.error('Error during login:', error);
      message.error('An error occurred during login.');
    }
  };

  return (
    <div style={styles.pageContainer}>
      <div style={styles.loginBox}>
        <h2 style={styles.title}>Login</h2>
        <Form onFinish={handleSubmit} style={styles.form}>
          <div style={styles.inputContainer}>
            <label style={styles.label}>Username</label>
            <Input
              value={formData.username}
              onChange={(e) => handleInputChange(e, 'username')}
              placeholder="Enter your username"
              style={styles.input}
            />
          </div>

          <div style={styles.inputContainer}>
            <label style={styles.label}>Password</label>
            <Input.Password
              value={formData.password}
              onChange={(e) => handleInputChange(e, 'password')}
              placeholder="Enter your password"
              style={styles.input}
            />
          </div>

          <Button type="primary" htmlType="submit" style={styles.submitButton}>
            Login
          </Button>
        </Form>
      </div>
    </div>
  );
};

const styles = {
  pageContainer: {
    backgroundColor: '#ffffff',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#000000',
  },
  loginBox: {
    backgroundColor: '#dddfe3',
    padding: '40px',
    borderRadius: '8px',
    width: '300px',
    textAlign: 'center',
  },
  title: {
    fontSize: '24px',
    fontWeight: 'bold',
    marginBottom: '20px',
  },
  form: {
    width: '100%',
  },
  inputContainer: {
    marginBottom: '16px',
    textAlign: 'left',
  },
  label: {
    display: 'block',
    fontSize: '14px',
    marginBottom: '6px',
    color:"#000000"
  },
  input: {
    width: '100%',
    height: '40px',
    fontSize: '16px',
  },
  submitButton: {
    width: '100%',
    height: '40px',
    fontSize: '16px',
    backgroundColor: '#273975',
    borderColor: '#273975',
  },
};

export default LoginPage;
